/* global axios */
// Serviço para consultar o DOM CRM via backend account-scoped.

import ApiClient from './ApiClient';

function cleanPhone(phone) {
  // Remove caracteres especiais e deixa apenas números
  return (phone || '').replace(/\D/g, '');
}

class DomcrmAPI extends ApiClient {
  constructor() {
    super('domcrm', { accountScoped: true });
  }

  buildError(error, fallbackMessage) {
    const serverMessage =
      error.response?.data?.error?.message ||
      error.response?.data?.message;

    const requestError = new Error(serverMessage || fallbackMessage);
    requestError.meta = error.response?.data?.meta || {};
    return requestError;
  }

  async getIdByPhone(phone) {
    const cleanedPhone = cleanPhone(phone);
    if (!cleanedPhone) {
      throw new Error('Telefone inválido');
    }

    try {
      const response = await axios.get(`${this.url}/getidbyphone`, {
        params: { phone: cleanedPhone },
      });
      return {
        data: response.data.data,
        meta: response.data.meta || {},
      };
    } catch (error) {
      throw this.buildError(error, 'Erro ao consultar DOM CRM');
    }
  }

  async getUserById(userId) {
    if (!userId) {
      throw new Error('ID do usuário inválido');
    }

    try {
      const response = await axios.get(`${this.url}/getuserbyid`, {
        params: { id: userId },
      });
      return {
        data: response.data.data,
        meta: response.data.meta || {},
      };
    } catch (error) {
      throw this.buildError(error, 'Erro ao consultar usuário no DOM CRM');
    }
  }
}

export default new DomcrmAPI();